function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#1AB6FF",
  d: "M.928 22.694H6.96a.937.937 0 00.929-.945V3.314a.937.937 0 00-.929-.946H.928A.937.937 0 000 3.314v18.435c0 .522.416.945.928.945z"
}), React.createElement("path", {
  fill: "#7BD5FF",
  d: "M47.212 10.641c-3.941 0-7.387 2.154-9.27 5.368.921.19 1.734.37 2.411.579 3.106.954 4.352 3.653 4.21 5.904-.13 2.065-1.414 3.656-3.194 3.958-.535.09-1.104.135-1.739.135-.698 0-1.408-.056-2.113-.13 1.754 3.65 5.435 6.166 9.695 6.166C53.17 32.62 58 27.7 58 21.63s-4.83-10.99-10.788-10.99z"
}), React.createElement("path", {
  fill: "#1AB6FF",
  d: "M36.999 12.85a12.597 12.597 0 015.841-3.625C37.96 4.2 34.132 1.13 29.656.478c-5.177-.753-14.29 2.995-18.946 4.037V20.74c2.658 1.069 6.038 3.54 8.906 3.954 5.566.804 10.097-.514 12.698-.514 2.6 0 5.462.8 7.782.406 2.32-.394 2.456-5.05-1.246-6.188-3.703-1.138-13.834-1.73-12.442-7.048.912-3.485 6.705-.78 10.59 1.5z"
}));

var SvgSpend = function SvgSpend(props) {
  return React.createElement("svg", _extends({
    width: 58,
    height: 33,
    viewBox: "0 0 58 33"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/spend.c4b3210e.svg";
export { SvgSpend as ReactComponent };